import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

export default function Blog() {
    const [posts, setPosts] = useState([]);
    useEffect(() => {
        api.get("/blog").then((r) => setPosts(r.data));
    }, []);

    return (
        <div
            className="max-w-[1200px] mx-auto px-6 md:px-12 pt-16 pb-32"
            data-testid="blog-page"
        >
            <div className="overline mb-4">The Journal</div>
            <h1
                className="font-serif text-5xl sm:text-6xl tracking-tight mb-6"
                style={{ color: "var(--vl-text)" }}
            >
                Intimate Wellness{" "}
                <em
                    style={{
                        color: "var(--vl-rose)",
                        fontStyle: "italic",
                    }}
                >
                    Guide.
                </em>
            </h1>
            <p
                className="max-w-2xl mb-16"
                style={{
                    color: "var(--vl-muted)",
                    lineHeight: 1.8,
                }}
            >
                Considered writing on bodies, pleasure, self-care, and the
                quiet art of living well.
            </p>

            <div className="grid md:grid-cols-2 gap-10">
                {posts.map((p, i) => (
                    <Link
                        to={`/blog/${p.slug}`}
                        key={p.id}
                        className={`group block ${i === 0 ? "md:col-span-2" : ""}`}
                        data-testid={`blog-card-${p.slug}`}
                    >
                        <div
                            className="relative overflow-hidden"
                            style={{
                                background: "var(--vl-surface)",
                                aspectRatio: i === 0 ? "21 / 9" : "4 / 3",
                            }}
                        >
                            <img
                                src={p.cover}
                                alt={p.title}
                                className="vl-img absolute inset-0 w-full h-full object-cover"
                                style={{ filter: "brightness(0.75)" }}
                            />
                        </div>
                        <div className="mt-5">
                            <div
                                className="overline"
                                style={{ color: "var(--vl-muted)" }}
                            >
                                {p.date} · {p.read_time}
                            </div>
                            <h2
                                className={`font-serif tracking-tight mt-3 group-hover:text-[var(--vl-rose)] transition-colors ${
                                    i === 0
                                        ? "text-3xl sm:text-4xl"
                                        : "text-2xl"
                                }`}
                                style={{ color: "var(--vl-text)" }}
                            >
                                {p.title}
                            </h2>
                            <p
                                className="mt-3 text-sm max-w-xl"
                                style={{
                                    color: "var(--vl-muted)",
                                    lineHeight: 1.7,
                                }}
                            >
                                {p.excerpt}
                            </p>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}
